import lodash from 'lodash';

const _defaultDocumentTypePermissions = () => {
    return {
        viewPDF:                   false,
        viewSource:                false,
        eSign:                     false,
        annotate:                  false,
        initialIndex:              false,
        index:                     false,
        reIndex:                   false,
        downloadPDF:               false,
        downloadPDFwithSignatures: false,
        downloadSource:            false,
        sdfa:                      false,
    };
};

export function documentFailedConversion(conversionStatus) {
    return conversionStatus !== 'success';
}

export function buildDocumentActions(document, binderId, documentTypes, actions, canManageIntegrationStatuses, extraOptions) {
    const { documentType, documentStatus } = document;
    const documentTypePermissions = buildDocumentTypePermissions(documentType, documentTypes);

    function goToDocumentIndex(indexingType, document, binderId) {
        const { push } = actions;
        const { id } = document;

        if (extraOptions && extraOptions.studyId) {
            let url = `/study/${extraOptions.studyId}/files/${id}/${indexingType}`;
            const from = lodash.get(extraOptions, 'from');
            if (from) url += `?from=${from}&docId=${id}`;
            push(url);
        } else {
            push(`/binder/${binderId}/files/${id}/${indexingType}`);
        }
    }

    actions.indexDocument = goToDocumentIndex;

    switch(documentStatus) {
        case 'unindexed':
            return buildUnindexedDocumentActions(document, binderId, documentTypes, actions);
        case 'indexed': {
            return buildIndexedDocumentActions(document, binderId, documentTypePermissions, actions, canManageIntegrationStatuses);
        }
        default:
            return [{
                label: 'No actions available',
                handler: () => { }
            }];
    }
}

export function buildDocumentTypePermissions(
    documentType = {},
    documentTypes = [],
    defaultDocumentTypePermissions = _defaultDocumentTypePermissions()
){
    const documentTypePermissions = lodash.get(documentTypes, [ documentType.id, 'permissions' ], {});
    return lodash.merge(defaultDocumentTypePermissions, documentTypePermissions);
}

export function buildUnindexedDocumentActions(document, binderId, documentTypes, {
    downloadRequest,
    indexDocument,
    deleteUnfiledDocument,
}) {
    const actions = [];
    if (lodash.find(documentTypes, d => d.permissions.initialIndex)) {
        actions.push({
            label: 'Assign Document Type',
            handler: () => indexDocument('initialIndex', document, binderId),
        });
    }
    // these actions are implicitly allowed based on the fact that the user
    // can see the unfiled documents page.
    actions.push({
        label: 'Download Source',
        handler: () => downloadRequest(document.id, null, 'ORIGINAL')
    }, {
        label: 'Delete',
        handler: () => deleteUnfiledDocument(document.id, true)
    });

    return actions;
}

export function buildIndexedDocumentActions(document, binderId, documentTypePermissions, {
    downloadRequest,
    indexDocument,
    signDocument,
    sendDocumentForAction,
}, canManageIntegrationStatuses) {

    if (documentFailedConversion(document.conversionStatus)) {
        return buildConversionFailedDocumentActions(document, binderId, documentTypePermissions, {
            downloadRequest,
            indexDocument,
        });
    }

    const actions = [];
    if (documentTypePermissions.downloadPDF) {
        actions.push({
            label: 'Download PDF',
            handler: () => downloadRequest(document.id, binderId, 'PDFA')
        });
    }
    if (documentTypePermissions.downloadPDFwithSignatures) {
        actions.push({
            label: 'Download PDF w/ Signature',
            handler: () => downloadRequest(document.id, binderId, 'SIGNED')
        });
    }
    if (documentTypePermissions.downloadPDFwithSignatures) {
        actions.push({
            label: 'Download PDF w/ History',
            handler: () => downloadRequest(document.id, binderId, 'HISTORY')
        });
    }
    if (documentTypePermissions.downloadSource) {
        actions.push({
            label: 'Download Source',
            handler: () => downloadRequest(document.id, binderId, 'ORIGINAL')
        });
    }
    if (canManageIntegrationStatuses || documentTypePermissions.index) {
        actions.push({
            label: 'Change Document Attribute',
            handler: () => indexDocument('index', document, binderId)
        });
    }
    if (documentTypePermissions.reIndex) {
        actions.push({
            label: 'Change Document Type',
            handler: () => indexDocument('reindex', document, binderId)
        });
    }
    if (documentTypePermissions.eSign) {
        actions.push({
            label: 'Sign the Document',
            handler: signDocument
        });
    }
    if(documentTypePermissions.sdfa){
        actions.push({
            label: 'Send Document for Action',
            handler: sendDocumentForAction
        });
    }

    return actions;
}

export function buildConversionFailedDocumentActions(document, binderId, documentTypePermissions, {
    downloadRequest,
    indexDocument,
}, canManageIntegrationStatuses) {
    const actions = [];

    if (documentTypePermissions.downloadSource) {
        actions.push({
            label: 'Download Source',
            handler: () => downloadRequest(document.id, binderId, 'ORIGINAL')
        });
    }
    if (canManageIntegrationStatuses || documentTypePermissions.index) {
        actions.push({
            label: 'Change Document Attribute',
            handler: () => indexDocument('index', document, binderId)
        });
    }
    if (documentTypePermissions.reIndex) {
        actions.push({
            label: 'Change Document Type',
            handler: () => indexDocument('reindex', document, binderId)
        });
    }

    return actions;
}
